import { createApp } from 'vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import Root from './Root.vue';
import VueSplide from '@splidejs/vue-splide';

createApp(Root).use(store).use(router).use(VueSplide).mount('#app');